import styles from "./perfil-rodrigo.module.css";
import PerfilCover from "../../../components/EquipeComponents/PerfilCover/perfil-cover";
import rodrigoPerfil from "../../../images/_finais/Rodrigo-Ribeiro_compress.webp";

const PerfilRodrigo = () => {
  const onClickLink = (link: string) => {
    return window.open(link, "_blank");
  };

  return (
    <main className={styles.perfil_main}>
      <PerfilCover
        title="Dr. Rodrigo Antonini Ribeiro"
        text="Possui vasta experiência na área de avaliação de tecnologias em saúde e 
        evidências de mundo real. Com sólida formação na área, incluindo mestrado e 
        doutorado em epidemiologia, possui mais de 80 publicações em periódicos indexados, 
        os quais possuem em conjunto mais de 2.000 citações. Desde 2015, já atendeu mais 
        de 20 indústrias farmacêuticas e de dispositivos médicos em projetos de acesso ao 
        mercado e evidências de mundo real."
        image={rodrigoPerfil}
        lattes={"http://lattes.cnpq.br/0227030470601631"}
        linkedin={"https://www.linkedin.com/in/rodrigo-antonini-ribeiro/"}
      />
      <p className={styles.descriptionMobile}>
        Possui vasta experiência na área de avaliação de tecnologias em saúde e
        evidências de mundo real. Com sólida formação na área, incluindo
        mestrado e doutorado em epidemiologia, possui mais de 80 publicações em
        periódicos indexados, os quais possuem em conjunto mais de 2.000
        citações. Desde 2015, já atendeu mais de 20 indústrias farmacêuticas e
        de dispositivos médicos em projetos de acesso ao mercado e evidências de
        mundo real.
      </p>
      <section className={styles.publicacoes}>
        <h3 className={styles.publicacoesTitle}>
          Publicações em Real World Evidence nos últimos anos:
        </h3>
        <ul className={styles.publicacoesList}>
          <li className={styles.publicacoesItem}>
            • Real-world evidence of health outcomes and medication use 24
            months after bariatric surgery in the public healthcare system in
            Brazil: a retrospective, single-center study. Clinics, v. 75, p. 1,
            2020.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.scielo.br/j/clin/a/vGLv7Mhj43jwNb6sfBp66JH/?format=html&lang=en"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Laparoscopic vs open colorectal surgery: Economic and clinical
            outcomes in the Brazilian healthcare. Medicine (Baltimore), v. 16,
            p. e22718, 2020.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink("https://pmc.ncbi.nlm.nih.gov/articles/PMC7572007/")
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Redução na Utilização de Recursos em Saúde e dos Custos após
            Ablação por Radiofrequência da Fibrilação Arial na Saúde Suplementar
            Brasileira , Arquivos Brasileiros de Cardiologia, v 113, pg 252-257.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.scielo.br/j/abc/a/zbwjcRD3WM9FkkGY7zwZnqC/?lang=pt&format=html"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • The Clinical and Economic Burden of Colorectal Anastomotic Leaks:
            Middle-Income Country Perspective. Gastroenterology Research and
            Practice, v. 2019, p. 1-7, 2019.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink("https://pmc.ncbi.nlm.nih.gov/articles/PMC6466886/")
              }
            >
              Ver
            </button>
          </li>
        </ul>
      </section>
    </main>
  );
};

export default PerfilRodrigo;
